(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.slick = {
    attach: function (context, settings) {

      if (typeof context['location'] !== 'undefined') {

        // See http://kenwheeler.github.io/slick/#settings

        $('.view-hero-slider .hero-slides').slick({
          dots: false,
          infinite: true,
          slidesToShow: 1,
          adaptiveHeight: true,
          prevArrow: $('.slick-slider-prev'),
          nextArrow: $('.slick-slider-next')
        });

      }

    }
  };

})(jQuery, Drupal, this, this.document);
